import React, { useState } from 'react';
// import { Box } from '@chakra-ui/react';
// import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
// import { PinSvg } from '../../../assets';
import SimpleMap from "./singleMap";

// mapboxgl.accessToken = process.env.REACT_APP_MAPTOKEN || '';

const Map = (props) => {
    const { latitude, longitude, map_zoom_level } = props;
    // const mapContainer = useRef(null);
    // const map = useRef(null);
    const [lng] = useState(longitude);
    const [lat] = useState(latitude);
    // const [zoom] = useState(map_zoom_level);

    // useEffect(() => {
    //     if (map.current) return; // initialize map only once
    //     map.current = new mapboxgl.Map({
    //         container: mapContainer.current,
    //         style: 'mapbox://styles/restlessmike/cl4gnqq0h000715p8pyyw3xf1',
    //         center: [lng, lat],
    //         zoom: zoom,
    //     });
    // });

    return (
        <>
            <div>
                {/*<Box ref={mapContainer} position={'absolute'} inset={0} />*/}
                {/*<PinSvg*/}
                {/*    style={{*/}
                {/*        position: 'absolute',*/}
                {/*        top: '50%',*/}
                {/*        left: '50%',*/}
                {/*        transform: 'translate(-50%,-50%)',*/}
                {/*    }}*/}
                {/*/>*/}
                <SimpleMap lat={lat} lng={lng} zoom={map_zoom_level}/>
            </div>
        </>
    );
};

export default Map;
